import type { Pool, PoolResources } from "~types/pool.ts";
import type { SeasonPoolTransformed } from "../types/seasonPoolTransformed.ts";

export const transformSeasonPool = (item: Pool, resources: PoolResources | undefined, seasonId: string): SeasonPoolTransformed => {
  const stage = item.stageCode ? resources?.seasonStages?.[`${seasonId}:${item.stageCode}`] : undefined;

  return {
    ...item,
    stage,
    stageName: stage?.nameLocal ?? null,
  };
};
